<template>
	<MStateBox :loading="initialLoading" :empty="isEmpty" class="act-container">
		<CScrollPro ref="scrollRef" pullDown @pull-down="onPullDown" pullUp :moreData="hasMoreData" @pull-up="onPullUp">
			<div class="offline-list">
				<div
					v-for="(item, index) in finalData"
					:key="index"
					class="offline-item"
					@click="viewOfflineDetail(item)"
				>
					<div class="offline-main">
						<div class="offline-title">
							<div :class="['offline-btn', `offline-btn--${meetingStatus(item)}`]" v-if="item.etime">
								{{ statusMap[meetingStatus(item)] }}
							</div>
							<span class="offline-con">{{ item.title }}</span>
						</div>
						<div class="offline-info">
							<p v-if="item.organizers" class="offline-organizer">{{ item.organizers }}</p>
							<p class="offline-time">{{ formatIrYear(item.stime) }}</p>
						</div>
					</div>
					<div
						v-if="item.logo43 || item.logo169"
						:class="['offline-header', item.sourceType == 0 ? 'logo169-image' : 'logo43-image']"
					>
						<m-lazy-img
							:imgType="item.sourceType == 0 ? 3 : 4"
							:imgUrl="item.sourceType == 0 ? item.logo169 : item.logo43"
						></m-lazy-img>
					</div>
				</div>
			</div>
		</CScrollPro>
	</MStateBox>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import MStateBox from '@rebuild/components/MStateBox.vue';
import CScrollPro from '@/view/enterprise/components/c-scroll-pro.vue';
import { formatIrYear } from '@/utils/api';
import { useModuleNavigation } from '@rebuild/hooks/useModuleNavigation';
import { useModuleData } from '@rebuild/hooks/data/useModuleData';
import { usePaginationMobile } from '@rebuild/hooks/load-more/usePaginationMobile';

const statusMap = { 1: '待开始', 2: '进行中', 3: '已结束' };
const meetingStatus = item => {
	const { stime, etime } = item;
	const now = Date.now();
	if (now < stime) return 1;
	if (now > etime) return 3;
	if (now >= stime && now <= etime) return 2;
	return 1;
};

const { offline } = useModuleData();
const { viewModule } = useModuleNavigation();
const viewOfflineDetail = item => viewModule('offline', item);

const loadData = async () => {
	await offline.refresh({ pageStart: currentPage.value - 1, pageNum: pageSize.value });

	const data = offline.data;
	const newData = data?.data || [];
	const total = data?.total || 0;
	setData(newData, total);
};

const { currentPage, pageSize, finalData, setData, hasMoreData, onPullDown, onPullUp } = usePaginationMobile({
	bindChange: loadData
});

// 首屏加载
const initialLoading = ref(true);
const isEmpty = computed(() => !initialLoading.value && finalData.value.length === 0);

onMounted(async () => {
	await loadData();
	initialLoading.value = false;
});
</script>

<style lang="less" scoped>
@import '@/style/mixins';
.act-container {
	height: 100%;
	background: #fff;
	padding: 0 0.12rem;
}

.offline-list {
	overflow: hidden;
}
.offline-item {
	display: flex;
	align-items: top;
	justify-content: flex-start;
	padding-bottom: 0.14rem;
	margin-bottom: 0.14rem;
	background: #ffffff;
	overflow: hidden;
	box-sizing: border-box;
	.thinner-border-bottom(#e8eaef);
	&:first-child {
		margin-top: 0.14rem;
	}
}
.logo43-image {
	margin-left: 0.08rem;
	width: 1.08rem;
	height: 0.81rem;
	border-radius: 0.02rem;
	flex-shrink: 0;
	img {
		width: 100%;
		height: 100%;
	}
}
.logo169-image {
	margin-left: 0.08rem;
	width: 1.08rem;
	height: 0.607rem;
	border-radius: 0.02rem;
	flex-shrink: 0;
	img {
		width: 100%;
		height: 100%;
	}
}
.offline-main {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	flex: 1;
	width: 0;
}
.offline-title {
	font-family: 'PingFang SC';
	color: #333;
	font-size: 0.15rem;
	font-weight: 500;
	line-height: 140%; /* 21px */
	.text-overflow-multi-row(2);
	.offline-con {
		max-height: 64px;
		.text-overflow-multi-row(2);
		display: inline;
	}
}
.offline-info {
	margin-top: 0.12rem;
	display: flex;
	align-items: center;
}

.offline-organizer {
	margin-right: 0.12rem;
}
.offline-organizer,
.offline-time {
	display: flex;
	align-items: center;
	color: #999;
	font-size: 0.12rem;
	font-weight: 400;
	line-height: 0.17rem;
}
.info-right {
	flex-shrink: 0;
}
.offline-btn {
	margin-right: 0.04rem;
	height: 0.16rem;
	padding: 0 0.04rem;
	display: inline-flex;
	align-items: center;
	font-family: 'PingFang SC';
	font-weight: 400;
	font-size: 0.11rem;
	line-height: 0.16rem;
	color: #fff;
	&--1 {
		background: var(--warning-color);
	}
	&--2 {
		background: var(--success-color);
	}
	&--3 {
		background: var(--error-color);
	}
}
</style>
